import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withCtx as _withCtx, renderList as _renderList, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23ced891"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex align-items-center justify-content-between flex-wrap gap-2" }
const _hoisted_2 = { class: "formula-set-banner" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "formula-set-status" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-lock" }),
  /*#__PURE__*/_createElementVNode("div", { class: "flex flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "formula-set-status__label" }, "Tariff formulas are built-in"),
    /*#__PURE__*/_createElementVNode("span", { class: "formula-set-status__hint" }, " Configured at commissioning to match the signed PPA, and frozen for the life of the project. ")
  ])
], -1))
const _hoisted_4 = { class: "formula-set-meta" }
const _hoisted_5 = { class: "formula-set-meta__item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "formula-set-meta__key" }, "Version", -1))
const _hoisted_7 = { class: "formula-set-meta__val" }
const _hoisted_8 = { class: "formula-set-meta__item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "formula-set-meta__key" }, "Checksum", -1))
const _hoisted_10 = { class: "formula-set-meta__val mono" }
const _hoisted_11 = { class: "formula-set-meta__item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "formula-set-meta__key" }, "Formulas", -1))
const _hoisted_13 = { class: "formula-set-meta__val" }
const _hoisted_14 = { class: "formula-tag" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "formula-expression" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  key: 0,
  class: "flex justify-content-between align-items-center"
}
const _hoisted_21 = {
  key: 0,
  class: "flex align-items-center"
}
const _hoisted_22 = {
  key: 1,
  class: "flex align-items-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PBlockUI = _resolveComponent("PBlockUI")!
  const _component_WTitle = _resolveComponent("WTitle")!
  const _component_PTag = _resolveComponent("PTag")!
  const _component_PColumn = _resolveComponent("PColumn")!
  const _component_PDataTable = _resolveComponent("PDataTable")!
  const _component_PButton = _resolveComponent("PButton")!
  const _component_PProgressSpinner = _resolveComponent("PProgressSpinner")!
  const _component_PCard = _resolveComponent("PCard")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PBlockUI, {
      blocked: _ctx.loading,
      fullScreen: ""
    }, null, 8, ["blocked"]),
    _createVNode(_component_PCard, null, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_WTitle, { text: "Tariff Calculations" }),
          _withDirectives(_createVNode(_component_PTag, {
            value: 'Read-only',
            icon: "pi pi-lock",
            severity: "success"
          }, null, 512), [
            [
              _directive_tooltip,
              `Tariff formulas are fixed in the deployed build and cannot be edited`,
              void 0,
              { left: true }
            ]
          ])
        ])
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("span", _hoisted_7, "v" + _toDisplayString(_ctx.formulaSet.version || '—'), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.formulaSet.checksum || '—'), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.formulaSet.count || _ctx.list.length), 1)
            ])
          ])
        ]),
        _createVNode(_component_PDataTable, {
          alwaysShowPaginator: false,
          highlightOnSelect: true,
          loading: _ctx.loading,
          resizableColumns: true,
          rowHover: true,
          rows: 100,
          showGridlines: true,
          sortOrder: 1,
          stripedRows: true,
          value: _ctx.list,
          class: "formula-table",
          "data-key": "id",
          paginator: "",
          size: "small"
        }, {
          empty: _withCtx(() => [
            _createTextVNode("No records found.")
          ]),
          default: _withCtx(() => [
            _createVNode(_component_PColumn, {
              bodyClass: "text-left",
              class: "justify-content-center",
              field: "tag",
              header: "Tag Name",
              headerClass: "py-3",
              sortable: "",
              style: {"width":"140px"}
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", _hoisted_14, [
                  (data.tagParts)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(data.tagParts.base), 1),
                        (data.tagParts.sub)
                          ? (_openBlock(), _createElementBlock("sub", _hoisted_15, _toDisplayString(data.tagParts.sub), 1))
                          : _createCommentVNode("", true),
                        (data.tagParts.sup)
                          ? (_openBlock(), _createElementBlock("sup", _hoisted_16, _toDisplayString(data.tagParts.sup), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(data.tag), 1)
                      ], 64))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_PColumn, {
              bodyClass: "text-left text-wrap",
              class: "justify-content-center",
              field: "formulaForDataTable",
              header: "Formula",
              headerClass: "py-3"
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("div", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.formula, (token, index) => {
                    return (_openBlock(), _createElementBlock("span", {
                      class: _normalizeClass(['formula-token', _ctx.tokenClass(token)]),
                      key: index
                    }, [
                      (token.kind === 'symbol')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(token.base), 1),
                            (token.sub)
                              ? (_openBlock(), _createElementBlock("sub", _hoisted_18, _toDisplayString(token.sub), 1))
                              : _createCommentVNode("", true),
                            (token.sup)
                              ? (_openBlock(), _createElementBlock("sup", _hoisted_19, _toDisplayString(token.sup), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(token.text), 1)
                          ], 64))
                    ], 2))
                  }), 128))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_PColumn, {
              bodyClass: "text-left",
              class: "justify-content-center",
              field: "unit",
              header: "Unit",
              headerClass: "py-3",
              style: {"width":"110px"}
            }),
            _createVNode(_component_PColumn, {
              bodyClass: "text-left text-wrap",
              field: "description",
              header: "Description",
              headerClass: "py-3"
            })
          ]),
          _: 1
        }, 8, ["loading", "value"]),
        (_ctx.appIsInLiveMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createVNode(_component_PButton, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.doTariffCalculations())),
                class: "mt-3",
                label: "Generate Invoice",
                size: "small"
              }),
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createTextVNode(" Generating invoice "),
                    _createVNode(_component_PProgressSpinner, {
                      animationDuration: "0.5s",
                      class: "ml-2",
                      strokeWidth: "6",
                      style: {"width":"25px","height":"25px"}
                    })
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.loading && _ctx.invoiceFilename)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createVNode(_component_PButton, {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.downloadInvoice())),
                      class: "mt-3",
                      label: "Save Invoice",
                      size: "small",
                      text: ""
                    })
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}